export default __webpack_public_path__ + "static/media/rnr-sports-table-3-cn.d9634d3a.webp";